/* istanbul ignore file */
export enum FilterFieldType {
	STRING = 'string',
	BOOLEAN = 'boolean',
	SELECT = 'select'
}
